import { SET_PRESETS } from "../actions/ActionTypes";

export default function PresetsReducer(
  state = [],
  action: Record<string, unknown>
): unknown {
  switch (action.type) {
    case SET_PRESETS:
      return action.payload;
    default:
      return state;
  }
}
